import React, { useEffect, useState } from 'react';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

// A new notice needs a new key, or every doctor who closed the last one never sees it.
const dismissedKey = (userId) =>
	`_ct_cavendish_name_notice_dismissed_${userId}`;

const HEADING = 'One Name. One Vision. An Exciting Future.';

const INTRO = [
	'We wanted to share some exciting news with you.',
	'CT Dent is becoming Cavendish Imaging, bringing the same trusted imaging service and team together under one name.',
	'For some time now, CT Dent and Cavendish Imaging have been operating closely together, sharing the same approach to patient care, imaging and supporting our referring clinicians.',
	'Now, we are bringing everything together under the one name: Cavendish Imaging.',
	'While the name is changing, the things that matter to you and your patients are not. You will continue to have access to the same trusted team, high-quality imaging and commitment to patient care that you know from CT Dent.',
];

const NEXT_CHAPTER = [
	'As part of this exciting next chapter, we are also preparing to launch a new Cavendish Imaging website and referrer portal, designed to make finding information and managing referrals simpler.',
	'Once the new portal is ready, CT Dent account holders will be automatically redirected there, and all existing data from the current CT Dent portal will be available.',
	'We will be sharing more information with you over the coming weeks, including everything you need to know about the transition.',
	'For now, there is nothing you need to do. We simply wanted to let you know that CT Dent is becoming Cavendish Imaging, bringing the same trusted imaging services and familiar team together under one name. We will keep you informed of any updates as the transition progresses.',
];

const useStyles = makeStyles((theme) => ({
	header: {
		backgroundColor: theme.palette.primary.main,
		color: theme.palette.primary.contrastText,
		padding: '20px 24px',
	},
	paragraph: {
		marginBottom: 12,
	},
	subheading: {
		fontWeight: 700,
		marginBottom: 12,
	},
	signOff: {
		marginTop: 20,
		fontWeight: 700,
	},
	actions: {
		padding: '12px 24px',
	},
}));

const AnnouncementPopup = ({ userId }) => {
	const classes = useStyles();
	const [open, setOpen] = useState(false);

	useEffect(() => {
		setOpen(!localStorage.getItem(dismissedKey(userId)));
	}, [userId]);

	const handleClose = () => {
		// Closed first: this dialog blocks the whole portal, so a failed write must not trap the doctor in it.
		setOpen(false);
		localStorage.setItem(dismissedKey(userId), 'true');
	};

	return (
		<Dialog
			open={open}
			maxWidth="md"
			fullWidth
			aria-labelledby="announcement-dialog-title"
		>
			<Typography
				id="announcement-dialog-title"
				variant="h5"
				component="h2"
				className={classes.header}
			>
				{HEADING}
			</Typography>
			<DialogContent dividers>
				{INTRO.map((text) => (
					<Typography key={text} variant="body1" className={classes.paragraph}>
						{text}
					</Typography>
				))}
				<Typography variant="body1" className={classes.subheading}>
					{HEADING}
				</Typography>
				{NEXT_CHAPTER.map((text) => (
					<Typography key={text} variant="body1" className={classes.paragraph}>
						{text}
					</Typography>
				))}
				<Typography variant="body1" className={classes.signOff}>
					Thank you for your continued support.
					<br />
					The Cavendish Imaging Team
				</Typography>
			</DialogContent>
			<DialogActions className={classes.actions}>
				<Button variant="contained" color="primary" onClick={handleClose}>
					Close
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default AnnouncementPopup;
